import { render } from "./CoverBlock.vue?vue&type=template&id=4a8e786f&scoped=true"
import script from "./CoverBlock.vue?vue&type=script&lang=js"
export * from "./CoverBlock.vue?vue&type=script&lang=js"

import "./CoverBlock.vue?vue&type=style&index=0&id=4a8e786f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4a8e786f"

export default script